module.exports = __webpack_public_path__ + "img/272.cd58d718.jpg";